export default __webpack_public_path__ + "7449d2f631a00860c2267e421cac2453.svg";